import { render, staticRenderFns } from "./Test5.vue?vue&type=template&id=5e7c9474&"
import script from "./Test5.vue?vue&type=script&lang=js&"
export * from "./Test5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports